import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  EDUCATION_OPTIONS,
  GENDER_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  OCCUPATION_OPTIONS,
} from "@/lib/accountProfile";

const selectClass = "h-12 w-full rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

const SELECT_FIELDS = [
  { key: "gender", id: "gender", options: GENDER_OPTIONS },
  { key: "education", id: "education", options: EDUCATION_OPTIONS },
  { key: "occupation", id: "occupation", options: OCCUPATION_OPTIONS },
  { key: "marital_status", id: "marital-status", options: MARITAL_STATUS_OPTIONS },
];

export function AccountNameField({ value, onChange, t, idPrefix = "account" }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={`${idPrefix}-name`}>{t("account.profile.name")}</Label>
      <Input
        id={`${idPrefix}-name`}
        data-testid={`${idPrefix}-name`}
        autoComplete="name"
        maxLength={80}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-12 bg-background"
      />
    </div>
  );
}

// Short demographic set common to psychological questionnaires. None is
// required to create or keep an account.
export function AccountDemographicFields({ profile, onChange, t, lang, idPrefix = "account" }) {
  const set = (key) => (event) => onChange({ ...profile, [key]: event.target.value });
  const today = new Date().toISOString().slice(0, 10);
  const label = (option) => option[`label_${lang}`] || option.label_id;
  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid={`${idPrefix}-demographics`}>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-birth-date`}>{t("account.profile.birth_date")}</Label>
        <Input
          id={`${idPrefix}-birth-date`}
          type="date"
          max={today}
          autoComplete="bday"
          value={profile.birth_date}
          onChange={set("birth_date")}
          className="h-12 bg-background"
        />
      </div>
      {SELECT_FIELDS.map((field) => (
        <div key={field.key} className="space-y-2">
          <Label htmlFor={`${idPrefix}-${field.id}`}>{t(`account.profile.${field.key}`)}</Label>
          <select id={`${idPrefix}-${field.id}`} value={profile[field.key]} onChange={set(field.key)} className={selectClass}>
            <option value="">{t("account.profile.unset")}</option>
            {field.options.map((option) => <option key={option.value} value={option.value}>{label(option)}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
}
